/**
 * Zwraca nazwe miesiąca dla podanej daty oraz rok
 *
 * @function
 * @param {Date} date - data
 * @returns {String}
 */
export const monthLabelPl = (date) =>
  date
    .toLocaleDateString("pl-PL", { month: "long", year: "numeric" })
    .replace(/^\w/, (c) => c.toUpperCase());

/**
 * Buduje listę opcji miesięcy cofając się o podaną liczbę miesięcy wstecz.
 *
 * Każdy element zawiera:
 * - `value`: w formacie "YYYY-MM" (np. "2025-09")
 * - `label`: nazwa miesiąca po polsku z rokiem, np. "Wrzesień 2025"
 *
 * @function
 * @param {number} [countBack=24] - Liczba miesięcy do wygenerowania wstecz od poprzedniego miesiąca
 * @returns {{ value: string, label: string }[]} Tablica obiektów opcji
 */
export const buildMonthOptions = (countBack = 24) => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return Array.from({ length: countBack }).map((_, i) => {
    const d = new Date(start.getFullYear(), start.getMonth() - i, 1);
    const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
    const label =
      monthLabelPl(d).charAt(0).toUpperCase() + monthLabelPl(d).slice(1);
    return { value, label };
  });
};

/**
 * Formatuje numer świadectwa, usuwa przedrostek "PL/KIG/"
 * Przykład: "PL/KIG/1234" -> "1234"
 */
export const formatCertificateNumber = (certNumber) => {
  if (!certNumber) return " - ";

  const lastSlashIndex = certNumber.lastIndexOf("/");
  const secondLastSlashIndex = certNumber.lastIndexOf("/", lastSlashIndex - 1);

  if (
    secondLastSlashIndex !== -1 &&
    secondLastSlashIndex < certNumber.length - 1
  ) {
    return certNumber.substring(secondLastSlashIndex + 1);
  }

  return certNumber;
};

export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString || typeof dateTimeString !== "string") {
    return { date: "", time: "" };
  }

  const [date, time] = dateTimeString.split(" ");
  return {
    date: date || "",
    time: time || "",
  };
};

export const capitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatNIP = (nip) => {
  if (!nip) return "";
  const clean = nip.replace(/\D/g, "");
  return clean.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1-$2-$3-$4");
};

export const formatOperatorName = (name) => {
  if (!name || name === "- -" || name === "-") return "-";

  const parts = name.split(" ");
  if (parts.length === 1) return name;

  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(" "),
  };
};
